module.exports = __webpack_public_path__ + "img/leaseFigure.877d5592.svg";